import React from "react";

const AddBanner = React.lazy(() => import("./Banner/add-banner"));
const Banner = React.lazy(() => import("./Banner/banner"));
const FAQ = React.lazy(() => import("./FAQ/faq"));
const FaqQuestion = React.lazy(() => import("./FAQ/faq-question"));
const Static = React.lazy(() => import("./StaticPages/static"));
const Blog = React.lazy(() => import("./Blog/blog"));
const AddBlog = React.lazy(() => import("./Blog/add-blog"));
const EditStatic = React.lazy(() => import("./StaticPages/edit-static"));
const AddNotification = React.lazy(() =>
  import("./Notifications/add-notification")
);
const PushNotifications = React.lazy(() =>
  import("./Notifications/push-notification")
);
export {
  AddBanner,
  AddBlog,
  Banner,
  FAQ,
  FaqQuestion,
  Static,
  EditStatic,
  PushNotifications,
  AddNotification,
  Blog
};
